/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AICategoryMiniReference,
    AICategoryMiniReferenceFromJSON,
    AICategoryMiniReferenceFromJSONTyped,
    AICategoryMiniReferenceToJSON,
    AIImageReference,
    AIImageReferenceFromJSON,
    AIImageReferenceFromJSONTyped,
    AIImageReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIAnnotationUpdate
 */
export interface AIAnnotationUpdate {
    /**
     * 
     * @type {AIImageReference}
     * @memberof AIAnnotationUpdate
     */
    image: AIImageReference;
    /**
     * 
     * @type {AICategoryMiniReference}
     * @memberof AIAnnotationUpdate
     */
    category: AICategoryMiniReference;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationUpdate
     */
    relativeLeft: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationUpdate
     */
    relativeTop: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationUpdate
     */
    relativeWidth: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationUpdate
     */
    relativeHeight: number;
    /**
     * 
     * @type {string}
     * @memberof AIAnnotationUpdate
     */
    track?: string;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotationUpdate
     */
    createdBy?: number | null;
}

export function AIAnnotationUpdateFromJSON(json: any): AIAnnotationUpdate {
    return AIAnnotationUpdateFromJSONTyped(json, false);
}

export function AIAnnotationUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIAnnotationUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'image': AIImageReferenceFromJSON(json['image']),
        'category': AICategoryMiniReferenceFromJSON(json['category']),
        'relativeLeft': json['relative_left'],
        'relativeTop': json['relative_top'],
        'relativeWidth': json['relative_width'],
        'relativeHeight': json['relative_height'],
        'track': !exists(json, 'track') ? undefined : json['track'],
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
    };
}

export function AIAnnotationUpdateToJSON(value?: AIAnnotationUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'image': AIImageReferenceToJSON(value.image),
        'category': AICategoryMiniReferenceToJSON(value.category),
        'relative_left': value.relativeLeft,
        'relative_top': value.relativeTop,
        'relative_width': value.relativeWidth,
        'relative_height': value.relativeHeight,
        'track': value.track,
        'created_by': value.createdBy,
    };
}


